import { ConfirmDialog } from '@gogame/components';
import { useScreenMessage, useScreenModalV2 } from '@gogame/screens';
import { useRequestProcessing } from '@gogame/query';

import {
  exportCreatives,
  checkExportCreatives,
} from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';
import {
  EXCEL,
  OVERSIZE_EXPORT_TEXT,
  ZIP,
} from 'scenes/Gallery/GalleryPage/constants';
import { exportCreatives as exportCreativesKey } from '../queryKeyFactory';
import { messagesCreatives } from '../messages';

// const STATUS_NOT_STARTED = 'NotStarted';
// const STATUS_RUNNING = 'Running';
const STATUS_COMPLETED = 'Completed';
const STATUS_FAILED = 'Failed';

const MB = 1024 * 1024;
const GB = MB * 1024;
const LIMIT_DOWNLOAD_SIZE = GB * 2;

export const useExportCreatives = ({ type }) => {
  const exportMessage =
    type === EXCEL ? messagesCreatives.export() : messagesCreatives.download();

  const { showMessage } = useScreenMessage('exportCreatives');

  const showDownloadDialog = useScreenModalV2(ConfirmDialog);

  const [mutateAsync, mutation] = useRequestProcessing(
    exportCreativesKey(),
    exportCreatives,
    checkExportCreatives,
    {
      refresh: false,
      isCompleted: (result) => result?.status === STATUS_COMPLETED,
      isFailed: (result) => result?.status === STATUS_FAILED,
      getCompletedMessage: () => exportMessage.completed(),
      getFailedMessage: () => exportMessage.failed(),
      getProcessMessage: (result) =>
        exportMessage.processing(result?.percentsCompleted),
      onCompleted: ({ url }) => {
        window.open(url, '_self');
      },
    }
  );

  return [
    async (params, { isAllow = true, isConfirm = true, size = 0 } = {}) => {
      if (isConfirm) {
        let title, bodyText, confirmActionLabel;

        if (!isAllow || size >= LIMIT_DOWNLOAD_SIZE) {
          return showMessage(
            `${OVERSIZE_EXPORT_TEXT}${
              size > 0 ? ` (${(size / GB).toFixed(2)} GB selected)` : ''
            }`
          );
        } else {
          if (type === EXCEL) {
            title = 'Export Creatives to Excel?';

            bodyText = params.ids
              ? 'Are you sure you want to export the selected creatives?'
              : 'Are you really sure you want to export all the creatives?';
            confirmActionLabel = 'Export';
          }
          if (type === ZIP) {
            title = 'Download Creatives?';
            bodyText = 'Are you really sure you want to download?';
            confirmActionLabel = 'Download';
            if (size > 0) bodyText += ` (${(size / MB).toFixed(2)} mb)`;
          }
        }

        await showDownloadDialog({
          title,
          bodyText,
          confirmActionLabel,
        });
      }

      return await mutateAsync({
        type,
        ...params,
      });
    },
    mutation,
  ];
};
